import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/suppliers")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "Suppliers",
  }),
});
